import { createAction } from 'redux-actions';
import { getUserOPMProfile } from 'api/current-user-api';
import { currentUserLoading, currentUserError } from './current-user-actions';
import { userAuth401Error } from './user-auth-actions';
import {
  setOpmServiceStatusForBanner,
  resetOpmServiceStatusForBanner,
} from './opm-service-actions';

export const setUserHomeGeo = createAction('SET_USER_HOME_GEO');

export const fetchUserOPMProfile = () => async (dispatch, getState) => {
  const fallbackGeo = window.TIEOUT.ENV.CURRENT_GEO;

  try {
    sessionStorage.removeItem('selected_project_id');
    dispatch(currentUserLoading());
    const opmResponse = await getUserOPMProfile();

    const { response } = opmResponse;
    if (response && response.status === 401) {
      await dispatch(userAuth401Error(response));
      return fallbackGeo;
    } else {
      const homeGeo = opmResponse?.response?.result?.geoCode;
      sessionStorage.setItem('home_geo', homeGeo);
      localStorage.setItem('home_geo', homeGeo);
      dispatch(setUserHomeGeo(opmResponse));

      const opmStatus = opmResponse?.response?.result?.opmStatus;
      if (opmStatus === 0) {
        dispatch(setOpmServiceStatusForBanner('DOWN'));
      } else if (opmStatus === 1) {
        dispatch(resetOpmServiceStatusForBanner());
      }

      return homeGeo;
    }
  } catch (error) {
    dispatch(currentUserError(error));
    return fallbackGeo;
  }
};
